import apiClient from 'services/axios'
import store from 'store'

export async function login(email, password) {
  return apiClient
    .post('/auth/login', {
      email,
      password,
    })
    .then(response => {
      if (response) {
        const { accessToken } = response.data.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function register(email, password, name) {
  return apiClient
    .post('/auth/register', {
      email,
      password,
      name,
    })
    .then(response => {
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function currentAccount() {
  return apiClient
    .get('/auth/me')
    .then(response => {
      if (response) {
        const { data } = response
        const { accessToken } = data || {}
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        // Admin model returns 'emails' (array) — normalize to the shape user saga expects
        if (data && data.emails) {
          return {
            ...data,
            email: Array.isArray(data.emails) ? data.emails[0] : data.emails,
            role: 'admin', // All users of admin panel are admins
          }
        }
        return data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function logout() {
  return store.clearAll()
}
